import { COUNTRY_AT } from './constants'
import { CDN_STATIONS_BASEURL, getCountry } from './utils'

const JOYN_STATIONS = new Set(['pro7', 'sat1', 'kabel-1', 'pro7-maxx', 'sixx'])
const TVNOW_STATIONS = new Set(['rtl', 'vox', 'rtl-nitro', 'rtl2', 'rtlplus', 'super-rtl', 'now'])

export class Station {
  constructor (slug, name, color, bgcolor, type, livetv) {
    this.slug = slug
    this.name = name
    this.logo = CDN_STATIONS_BASEURL + '/' + slug + '.png'
    this.logoWhite = CDN_STATIONS_BASEURL + '/white/' + slug + '.png'
    this.color = color || 'inherit'
    this.bgcolor = bgcolor || 'none'
    this.type = type
    this.livetv = livetv
  }

  toJSON () {
    return {
      slug: this.slug,
      name: this.name,
      logo: this.logo,
      logoWhite: this.logoWhite,
      color: this.color,
      bgcolor: this.bgcolor,
      livetv: this.livetv ? this.livetv : ''
    }
  }
}

const stationTypes = [
  { name: 'TV aus Österreich', key: 'at' },
  { name: 'Hauptsender', key: 'main' },
  { name: 'Spartensender', key: 'branch' },
  { name: 'Regionale/Dritte', key: 'region' },
  { name: 'Info', key: 'info' }
]

const stations = [
// most seen AT
  new Station('atv', 'ATV', '#EE1803', '#fff', 'at', 'https://www.atv.at/livestream'),
  new Station('puls-4', 'Puls 4', '#E6006E', '#F3EDED', 'at', 'https://www.puls4.com/livestream'),
  new Station('servustv', 'ServusTV', '#000', '#fff', 'at', 'https://www.servustv.com/jetzt-live/'),
  // most seen DE
  new Station('ard', 'Das Erste', '#01357F', '#fff', 'main', 'http://live.daserste.de'),
  new Station('zdf', 'ZDF', '#fff', '#34393f', 'main', 'https://www.zdf.de/live-tv'),
  new Station('orf-1', 'ORF 1', '#fff', '#5286C1', 'at', 'https://tvthek.orf.at/live'),
  new Station('orf-2', 'ORF 2', '#fff', '#5286C1', 'at', 'https://tvthek.orf.at/live'),
  new Station('orf-3', 'ORF 3', '#fff', '#5286C1', 'at', 'https://tvthek.orf.at/live'),
  new Station('3sat', '3sat', '#EC0B28', '#FEFEFE', 'main', 'https://www.3sat.de/programm/3sat-livestream-100.html'),
  new Station('arte', 'ARTE', '#fff', '#161616', 'main', 'https://www.arte.tv/de/live/'),
  new Station('orfsportplus', 'ORF Sport+', '#fff', '#5286C1', 'at', 'https://tvthek.orf.at/live'),
  // AT others
  // Geblockt
  new Station('rtl', 'RTL', '#fff', '#3DB7C7', 'main', 'https://www.tvnow.de/live-tv/rtl'),
  new Station('sat1', 'SAT1', '#fff', '#083E51', 'main', 'https://www.joyn.de/play/live-tv?channel_id=2'),
  new Station('pro7', 'Pro7', '#fff', '#132332', 'main', 'https://www.joyn.de/play/live-tv?channel_id=1'),
  new Station('kabel-1', 'kabel 1', '#fff', '#13081B', 'main', 'https://www.joyn.de/play/live-tv?channel_id=3'),
  new Station('okto', 'OKTO', '#000', '#fff', 'at', 'https://www.okto.tv/de/tv/'),
  new Station('vox', 'VOX', '#000', '#EDEDED', 'main', 'https://www.tvnow.de/live-tv/vox'),
  // locals
  new Station('swr', 'SWR', '#082555', '#fff', 'region', 'https://www.ardmediathek.de/live/Y3JpZDovL3N3ci5kZS8xMzQ4MTIzMA'),
  new Station('ndr', 'NDR', '#000', '#fff', 'region', 'https://www.ndr.de/fernsehen/livestream/index.html'),
  new Station('wdr', 'WDR', '#01345E', '#fff', 'region', 'https://www1.wdr.de/mediathek/video/live/index.html'),
  new Station('br', 'BR', '#50555D', '#fff', 'region', 'https://www.br.de/mediathek/live'),
  new Station('mdr', 'mdr', '#313131', '#fff', 'region', 'https://www.mdr.de/video/livestreams/fernsehen/index.html'),
  new Station('sr', 'SR', '#054694', '#fff', 'region', 'https://www.sr.de/sr/fernsehen/livestream/livestream_fernsehen102.html#'),
  new Station('rbb', 'rbb', '#E3191A', '#fff', 'region', 'https://www.rbb-online.de/fernsehen/live/'),
  new Station('radio-bremen', 'Radio Bremen', '#fff', '#E3001B', 'region', 'https://www.butenunbinnen.de/livestream/livestream102.html'),
  new Station('hr', 'hr', '#000', '#fff', 'region', 'https://www.hr-fernsehen.de/livestream/livestream_hr-fernsehen-100.html'),
  // secondaries
  new Station('ard-alpha', 'ARD-alpha', '#C94F16', '#fff', 'branch', 'https://www.br.de/mediathek/live/ard-alpha/av:584f4be43b467900117bdad5'),
  new Station('sixx', 'sixx', '#fff', '#1E282B', 'branch', 'https://www.joyn.de/play/live-tv?channel_id=4'),
  new Station('rtl-nitro', 'RTL NITRO', '#B8E736', '#07343D', 'branch', 'https://www.tvnow.de/live-tv/nitro'),
  new Station('rtl2', 'RTL2', '#14BCF5', '#fff', 'main', 'https://www.tvnow.de/live-tv/rtl2'),
  new Station('pro7-maxx', 'Pro7 MAXX', '#2D2D27', '#E6E6D9', 'branch', 'https://www.prosiebenmaxx.de/livestream'),
  new Station('one', 'ONE', '#d6004f', '#ffffff', 'branch', 'https://www.ardmediathek.de/one/live/Y3JpZDovL3dkci5kZS9CZWl0cmFnLTFlNjA0YWFlLTViODctNGMzNC04ZDhmLTg4OWI1ZjE2ZDU3Mw/'),
  new Station('rtlplus', 'RTLplus', '#7E2160', '#E2EBEE', 'branch', 'https://www.tvnow.de/live-tv/rtlplus'),
  new Station('super-rtl', 'Super RTL', '#fff', '#DDB7D7', 'branch', 'https://www.tvnow.de/live-tv/superrtl'),
  new Station('now', 'NOW!', '#fff', '#2D3538', 'branch', 'https://www.tvnow.de/live-tv/nowus'),
  // kids and news
  new Station('kika', 'KiKa', '#025D63', '#55B9C9', 'branch', 'https://www.kika.de/live/live-100'),
  new Station('phoenix', 'Phoenix', '#00687C', '#FFFFFF', 'info', 'https://www.phoenix.de/livestream.html'),
  new Station('n-tv', 'n-tv', '#fff', '#2D3D46', 'info', 'https://www.n-tv.de/mediathek/livestream/24-Stunden-ntv-Livestream-article9511936.html'),
  new Station('deutsche-welle', 'Deutsche Welle', '#77C0FF', '#fff', 'info', 'https://www.dw.com/de/live-tv/channel-english')
]

function availableStations () {
  const country = getCountry()
  let availableStations
  if (country === COUNTRY_AT) {
    availableStations = stations
  } else {
    availableStations = stations.filter(station => station.type !== 'at')
  }
  return availableStations
}

export function getStations () {
  const result = availableStations().map(s => s.toJSON())
  return result
}

export function getStation (slug) {
  return availableStations().find(station => station.slug === slug)
}

export function getStationTypes () {
  const country = getCountry()
  let availableTypes
  if (country === COUNTRY_AT) {
    availableTypes = stationTypes
  } else {
    availableTypes = stationTypes.filter(type => type.key !== 'at')
  }
  return availableTypes
}

export function getStationsByType (type) {
  return availableStations().filter(station => station.type === type)
}

export function isJoynStation (station) {
  return JOYN_STATIONS.has(station)
}

export function isPro7Campaign (station) {
  return isJoynStation(station) && process.env.PRO_CAMPAIGN_ENABLED === 'true'
}

export function isTVNowStation (station) {
  return TVNOW_STATIONS.has(station)
}
